import { CALL_API } from '../middleware/api';

// ─── Fetch list ────────────────────────────────────────────
export const PROPOSALS_REQUEST = 'PROPOSALS_REQUEST';
export const PROPOSALS_SUCCESS = 'PROPOSALS_SUCCESS';
export const PROPOSALS_FAILURE = 'PROPOSALS_FAILURE';

// ─── Create ────────────────────────────────────────────────
export const PROPOSAL_CREATE_REQUEST = 'PROPOSAL_CREATE_REQUEST';
export const PROPOSAL_CREATE_SUCCESS = 'PROPOSAL_CREATE_SUCCESS';
export const PROPOSAL_CREATE_FAILURE = 'PROPOSAL_CREATE_FAILURE';

// ─── Update ────────────────────────────────────────────────
export const PROPOSAL_UPDATE_REQUEST = 'PROPOSAL_UPDATE_REQUEST';
export const PROPOSAL_UPDATE_SUCCESS = 'PROPOSAL_UPDATE_SUCCESS';
export const PROPOSAL_UPDATE_FAILURE = 'PROPOSAL_UPDATE_FAILURE';

// ─── Delete ────────────────────────────────────────────────
export const PROPOSAL_DELETE_REQUEST = 'PROPOSAL_DELETE_REQUEST';
export const PROPOSAL_DELETE_SUCCESS = 'PROPOSAL_DELETE_SUCCESS';
export const PROPOSAL_DELETE_FAILURE = 'PROPOSAL_DELETE_FAILURE';

// ─── Misc ──────────────────────────────────────────────────
export const PROPOSALS_RESET = 'PROPOSALS_RESET';

// ─── Action Creators ───────────────────────────────────────

export function fetchProposals() {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: 'proposals',
      authenticated: true,
      types: [PROPOSALS_REQUEST, PROPOSALS_SUCCESS, PROPOSALS_FAILURE],
    },
  };
}

export function createProposal(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'proposals',
      body: JSON.stringify(data),
      authenticated: true,
      types: [PROPOSAL_CREATE_REQUEST, PROPOSAL_CREATE_SUCCESS, PROPOSAL_CREATE_FAILURE],
    },
  };
}

export function updateProposal(id, data) {
  return {
    [CALL_API]: {
      method: 'PUT',
      endpoint: `proposals/${id}`,
      body: JSON.stringify(data),
      authenticated: true,
      types: [PROPOSAL_UPDATE_REQUEST, PROPOSAL_UPDATE_SUCCESS, PROPOSAL_UPDATE_FAILURE],
    },
  };
}

export function deleteProposal(id) {
  return {
    [CALL_API]: {
      method: 'DELETE',
      endpoint: `proposals/${id}`,
      authenticated: true,
      types: [PROPOSAL_DELETE_REQUEST, PROPOSAL_DELETE_SUCCESS, PROPOSAL_DELETE_FAILURE],
    },
  };
}

export function resetProposals() {
  return { type: PROPOSALS_RESET };
}
